import React from "react";
import MapContainer from "./MapContainer";
import { CardContent } from "@material-ui/core";
export const JobPackMapView = ({ jobPacks, redirectTo, st , year, month, mapKey }) => {
    return (
        <CardContent>
            {jobPacks && (
                <div
                    style={{
                        width: "100%",
                        height: "100%"
                    }}
                >
                    <MapContainer
                        style={{
                            width: "100%",
                            height: "100%"
                        }}
                        jobList={jobPacks}
                        redirect={redirectTo}
                        st={st}
                        year={year}
                        month={month}
                        mapKey={mapKey}
                    />
                </div>
            )}
        </CardContent>
    );
};
